var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyEthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 784.37 1277.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m392.07 0-8.57 29.11v844.63l8.57 8.55 392.06-231.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 0 0 650.54l392.07 231.75V472.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "m392.07 956.52-4.83 5.89v300.87l4.83 14.1 392.3-552.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 1277.38V956.52L0 724.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m392.07 882.29 392.06-231.75-392.06-178.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m0 650.54 392.07 231.75V472.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyEthLogo);
export default __webpack_public_path__ + "static/media/currency-eth-logo.d0489e27d96c2c8b8c0e8cf0c2647053.svg";
export { ForwardRef as ReactComponent };